export const ResetText = {
	_1: 'Reset Your Password',
	_2: 'New Password',
	_3: 'Confirm New Password',
	_4: 'Reset'
}

export default ResetText;


// WEBPACK FOOTER //
// ./src/input-text/en/reset.js